import { render, staticRenderFns } from "./OverviewComponent.vue?vue&type=template&id=6da3d5a2&scoped=true"
import script from "./OverviewComponent.vue?vue&type=script&lang=ts"
export * from "./OverviewComponent.vue?vue&type=script&lang=ts"
import style0 from "./OverviewComponent.vue?vue&type=style&index=0&id=6da3d5a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da3d5a2",
  null
  
)

export default component.exports